import { nullSafeGetOrElse } from './DataAccessUtils';

// Helpers over the SERVER-computed deliverable fields. The backend returns
// workOrderMetrics / taskMetrics / budgetUsed already computed on GET
// (openwrench-app ProjectDeliverableServiceImpl.hydrateEntity) — the client
// never derives these, it only formats them.

// Work-order buckets on a deliverable (distinct from the deliverable's own
// status). Labels come from the WO rollup, not the deliverable status enum.
export const WORK_ORDER_METRIC_ROWS = [
	{ key: 'workOrdersNotStarted', label: 'Not Started' },
	{ key: 'workOrdersInProgress', label: 'In Progress' },
	{ key: 'workOrdersClosed', label: 'Completed' },
	{ key: 'workOrdersPaid', label: 'Paid' },
];

export const workOrderMetricsTotal = (metrics): number =>
	WORK_ORDER_METRIC_ROWS.reduce((total, row) => total + nullSafeGetOrElse(row.key, metrics, 0), 0);

// Work orders considered "done" — closed + paid. Numerator for the "3/4" rollup.
export const workOrdersDoneCount = (metrics): number =>
	nullSafeGetOrElse('workOrdersClosed', metrics, 0) +
	nullSafeGetOrElse('workOrdersPaid', metrics, 0);

export const budgetPercentUsed = (budget, budgetUsed): number => {
	const total = Number(budget) || 0;
	if (total <= 0) {
		return 0;
	}
	return Math.round(((Number(budgetUsed) || 0) * 100) / total);
};

export const formatCurrency = (amount): string => `$${(Number(amount) || 0).toLocaleString()}`;
